import {
    VariantText,
    VariantTextProps
} from 'pages/special/OsloDesignFair/map/markers/view/VariantIconMarkers/VariantIconMarker/elements/VariantText.tsx';
import styled, { CSSProperties } from 'styled-components';

interface VariantWrapTextProps {
    top: number;
    variantText: VariantTextProps;
    style?: CSSProperties;
    className?: string;
}

export const VariantWrapText = (props: VariantWrapTextProps) => {
    return (
        <S_VariantWrapText className={props.className} style={props.style} $top={props.top}>
            <VariantText {...props.variantText} />
        </S_VariantWrapText>
    );
};

const S_VariantWrapText = styled.div<{ $top: number }>`
    position: absolute;
    top: ${({ $top }) => $top}px;
    left: 0;
    width: 130px;
    display: flex;
    justify-content: center;
    left: 50%;
    transform: translateX(-50%);
`;
